import styles from './Skeleton.module.css'

export interface SkeletonProps {
  width?: string
  height?: string
}

/**
 * A single skeleton shape matching the surface's structure — addendum §A's
 * loading state. Under 100ms of actual load time, don't render this at all
 * (a flash of skeleton is worse than a brief blank); that decision belongs
 * to the calling surface, not to this primitive.
 */
export function Skeleton({ width = '100%', height = '1em' }: SkeletonProps) {
  return (
    <span
      className={styles['skeleton']}
      style={{ width, height }}
      role="presentation"
      aria-hidden="true"
    />
  )
}
